<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Senarai Agensi Pembayar">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input label="Kod Agensi"
                            v-model="cari.kod"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input label="Nama Agensi" 
                            v-model="cari.nama"/>
                    </div>
                </w-flex>
                <w-flex class="mt3">

                    <div class="xs6 mr3">
                        <w-input label="Nama Jabatan"  v-model="cari.nama_id"/>
                    </div>

                    <div class="xs6 mr3">
                        <w-input
                            required
                            label="Emel " v-model="cari.emel"
                        />
                    </div>
                </w-flex>
                <w-flex class="mt3">
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                      bg-color="success"
                      class="mr2"
                        @click="daftar"
                      ><w-icon>fal fa-print</w-icon>&nbsp;Daftar</w-button>
                    <!-- <w-button
                      bg-color="success"
                      class="mr2"
                      ><w-icon>fal fa-print</w-icon>&nbsp;Cetak</w-button> -->
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()" :loading="cari.loading">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>
            <br>
                <center v-if="cari.loading"><w-progress class="ma1" circle></w-progress></center>
            <z-table
                ref="tbluser"
                title="Agensi Pembayar"
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >
            
                
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        Tindakan
                    </template>
                </template>
                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                           <inertia-link :href='$route("perumahan-agensi.agensi.show",item.id)'>
                            <w-tooltip top>
                               <template #activator="{ on }">
                                 <w-icon v-on="on" >
                                   fal fa-file
                                 </w-icon>
                               </template>
                               Papar
                             </w-tooltip>
                            </inertia-link>
                    </w-flex>
                </template>
            </z-table>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
// import ZenOne from '@/Shared/ZenOne'
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_tunggakan + "perumahan_agensi/agensi",
            reload: true,
            form_profil: {},
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/ihasil" },
                { label: "Perumahan", route: "/perumahan" },
                { label: "Agensi Pembayaran", route: "/perumahan/agensi" },
                { label: "Senarai Agensi Pembayar ", route: "/perumahan/agensi" },
            ],
            cari: {
                kod: '' ,
                nama: "",
                nama_id :'',
                emel :'',
            },
        };
    },
    methods: {
        search() {
            this.cari.loading = true
            this.$inertia.visit(
                window.route('perumahan-agensi.agensi.index') +
                    '?kod=' +
                    this.cari.kod +
                    '&nama=' +
                    this.cari.nama+
                    '&nama_id=' +
                    this.cari.nama_id+
                    '&emel=' +
                    this.cari.emel,
                { preserveScroll: true }
            );
        },

        reset() {
            this.cari = {
                kod: "",
                nama: "",
                nama_id: "",
                emel: "",
            };
            this.search();
        },

        daftar(){
                this.$inertia.visit(window.route('perumahan-agensi.agensi.daftar'));
        },
    },
    watch: {},
    mounted() {
        // override default setting
        // this.getData();
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.kod == "undefined") {
            this.cari.kod = "";
        }
        if (this.cari.nama == "undefined") {
            this.cari.nama = "";
        }
        if (this.cari.nama_id == "undefined") {
            this.cari.nama_id = "";
        }
        if (this.cari.emel == "undefined") {
            this.cari.emel = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
